import { useCallback, useEffect, useState } from 'react'

const useCopyCode = (code: string) => {
  const [copiedCode, setCopiedCode] = useState(false)

  const handleCopyCode = useCallback(() => {
    navigator.clipboard.writeText(code)
    setCopiedCode(true)
  }, [code])

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    if (copiedCode) {
      timer = setTimeout(() => {
        setCopiedCode(false)
      }, 3000)
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [copiedCode, setCopiedCode])

  return { copiedCode, handleCopyCode }
}

export default useCopyCode
